/**
 * An object whose keys and values properties must be strings.
 */
export type StringObjectModel = {[key: string]: string};
